// extracted by mini-css-extract-plugin
export default {"composer__action":"composer__action__4V4O-"};